(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-hero"] && !Shopify.designMode) return;
  try {
    

(function () {

  /* ==========================================================
     DEVICE
  ========================================================== */

  function getDevice() {

    var width =
      window.innerWidth;


    if (width >= 1600) {

      return 'large_desktop';

    }


    if (width >= 1100) {

      return 'desktop';

    }


    if (width >= 750) {

      return 'tablet';

    }


    return 'mobile';

  }



  /* ==========================================================
     LOAD FRAME
  ========================================================== */

  function loadFrame(frame) {

    return new Promise(
      function (resolve) {

        if (!frame) {

          resolve();

          return;

        }


        if (!frame.getAttribute('src')) {

          var source =
            frame.getAttribute(
              'data-src'
            );


          if (source) {

            frame.setAttribute(
              'src',
              source
            );

          }

        }


        if (frame.complete) {

          if (frame.decode) {

            frame
              .decode()
              .catch(
                function () {}
              )
              .finally(
                resolve
              );

          } else {

            resolve();

          }


          return;

        }


        frame.addEventListener(
          'load',
          resolve,
          {
            once: true
          }
        );


        frame.addEventListener(
          'error',
          resolve,
          {
            once: true
          }
        );

      }
    );

  }



  /* ==========================================================
     STOP SEQUENCE
  ========================================================== */

  function stopSequence(sequence) {

    if (!sequence) return;


    if (sequence.__hhFrameInterval) {

      clearInterval(
        sequence.__hhFrameInterval
      );


      sequence.__hhFrameInterval =
        null;

    }

  }



  /* ==========================================================
     RESET FRAMES
  ========================================================== */

  function resetFrames(sequence) {

    if (!sequence) return;


    var frames =
      Array.from(
        sequence.querySelectorAll(
          '[data-hh-frame]'
        )
      );


    frames.forEach(
      function (frame, index) {

        frame.classList.toggle(
          'is-active',
          index === 0
        );

      }
    );

  }



  /* ==========================================================
     START SEQUENCE
  ========================================================== */

  function startSequence(
    section,
    sequence
  ) {

    if (!sequence) return;


    stopSequence(
      sequence
    );


    var frames =
      Array.from(
        sequence.querySelectorAll(
          '[data-hh-frame]'
        )
      );


    if (!frames.length) return;


    resetFrames(
      sequence
    );


    Promise.all(
      frames.map(
        loadFrame
      )
    ).then(
      function () {

        if (
          !sequence.classList.contains(
            'is-current'
          )
        ) {

          return;

        }


        if (frames.length <= 1) {

          return;

        }


        var reduceMotion =
          window.matchMedia &&
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;


        if (reduceMotion) {

          return;

        }


        var styles =
          window.getComputedStyle(
            section
          );


        var duration =
          parseInt(
            styles.getPropertyValue(
              '--hh-frame-duration'
            ),
            10
          );


        if (
          !duration ||
          duration < 100
        ) {

          duration =
            1200;

        }


        var current = 0;


        sequence.__hhFrameInterval =
          setInterval(
            function () {

              if (
                !sequence.classList.contains(
                  'is-current'
                )
              ) {

                stopSequence(
                  sequence
                );

                return;

              }


              frames[current]
                .classList
                .remove(
                  'is-active'
                );


              current =
                (current + 1) %
                frames.length;


              frames[current]
                .classList
                .add(
                  'is-active'
                );

            },
            duration
          );

      }
    );

  }



  /* ==========================================================
     ACTIVE RESPONSIVE SEQUENCE
  ========================================================== */

  function updateActiveSequence(
    section
  ) {

    if (!section) return;


    var sequences =
      Array.from(
        section.querySelectorAll(
          '[data-hh-frame-sequence]'
        )
      );


    if (!sequences.length) {

      return;

    }


    var device =
      getDevice();


    var matchingSequence =
      sequences.find(
        function (sequence) {

          return (
            sequence.getAttribute(
              'data-device'
            ) === device
          );

        }
      );


    if (!matchingSequence) {

      matchingSequence =
        sequences.find(
          function (sequence) {

            return (
              sequence.getAttribute(
                'data-device'
              ) === 'desktop'
            );

          }
        );

    }


    if (!matchingSequence) {

      matchingSequence =
        sequences[0];

    }


    sequences.forEach(
      function (sequence) {

        var active =
          sequence ===
          matchingSequence;


        sequence
          .classList
          .toggle(
            'is-current',
            active
          );


        if (!active) {

          stopSequence(
            sequence
          );


          resetFrames(
            sequence
          );

        }

      }
    );


    if (
      section.__hhCurrentSequence !==
      matchingSequence
    ) {

      section.__hhCurrentSequence =
        matchingSequence;


      startSequence(
        section,
        matchingSequence
      );

    }

  }



  /* ==========================================================
     IMAGE SEQUENCE INIT
  ========================================================== */

  function initImageSequences(
    section
  ) {

    if (!section) return;


    if (
      section.__hhSequenceResizeHandler
    ) {

      window.removeEventListener(
        'resize',
        section.__hhSequenceResizeHandler
      );

    }


    if (
      section.__hhSequenceResizeTimer
    ) {

      clearTimeout(
        section.__hhSequenceResizeTimer
      );

    }


    section.__hhCurrentSequence =
      null;


    section.__hhLastDevice =
      getDevice();


    updateActiveSequence(
      section
    );


    section.__hhSequenceResizeHandler =
      function () {

        clearTimeout(
          section.__hhSequenceResizeTimer
        );


        section.__hhSequenceResizeTimer =
          setTimeout(
            function () {

              var newDevice =
                getDevice();


              if (
                section.__hhLastDevice !==
                newDevice
              ) {

                section.__hhLastDevice =
                  newDevice;


                section.__hhCurrentSequence =
                  null;


                updateActiveSequence(
                  section
                );

              }

            },
            120
          );

      };


    window.addEventListener(
      'resize',
      section.__hhSequenceResizeHandler
    );

  }



  /* ==========================================================
     IMAGE SEQUENCE CLEANUP
  ========================================================== */

  function cleanupImageSequences(
    section
  ) {

    if (!section) return;


    var sequences =
      section.querySelectorAll(
        '[data-hh-frame-sequence]'
      );


    sequences.forEach(
      function (sequence) {

        stopSequence(
          sequence
        );

      }
    );


    if (
      section.__hhSequenceResizeHandler
    ) {

      window.removeEventListener(
        'resize',
        section.__hhSequenceResizeHandler
      );


      section.__hhSequenceResizeHandler =
        null;

    }


    if (
      section.__hhSequenceResizeTimer
    ) {

      clearTimeout(
        section.__hhSequenceResizeTimer
      );


      section.__hhSequenceResizeTimer =
        null;

    }


    section.__hhCurrentSequence =
      null;

  }



  /* ==========================================================
     CLEAN GENERATED MARQUEE CLONES
  ========================================================== */

  function cleanClone(element) {

    if (!element) return;


    var elements =
      [element].concat(
        Array.from(
          element.querySelectorAll('*')
        )
      );


    elements.forEach(
      function (node) {

        if (!node.attributes) {

          return;

        }


        Array.from(
          node.attributes
        ).forEach(
          function (attribute) {

            if (
              attribute.name.indexOf(
                'data-shopify-editor'
              ) === 0
            ) {

              node.removeAttribute(
                attribute.name
              );

            }

          }
        );

      }
    );

  }



  /* ==========================================================
     MARQUEE CLEANUP
  ========================================================== */

  function cleanupMarquee(
    section
  ) {

    if (!section) return;


    if (
      section.__hhResizeObserver
    ) {

      section.__hhResizeObserver
        .disconnect();


      section.__hhResizeObserver =
        null;

    }


    if (
      section.__hhMarqueeResizeHandler
    ) {

      window.removeEventListener(
        'resize',
        section.__hhMarqueeResizeHandler
      );


      section.__hhMarqueeResizeHandler =
        null;

    }


    if (
      section.__hhMarqueeResizeTimer
    ) {

      clearTimeout(
        section.__hhMarqueeResizeTimer
      );


      section.__hhMarqueeResizeTimer =
        null;

    }

  }



  /* ==========================================================
     MARQUEE
  ========================================================== */

  function initMarquee(
    section
  ) {

    if (!section) return;


    cleanupMarquee(
      section
    );


    var viewport =
      section.querySelector(
        '[data-hh-marquee-viewport]'
      );


    var track =
      section.querySelector(
        '[data-hh-marquee-track]'
      );


    var primaryGroup =
      section.querySelector(
        '[data-hh-marquee-primary]'
      );


    var cloneGroup =
      section.querySelector(
        '[data-hh-marquee-clone]'
      );


    if (
      !viewport ||
      !track ||
      !primaryGroup ||
      !cloneGroup
    ) {

      return;

    }


    if (
      !section.__hhOriginalItems
    ) {

      section.__hhOriginalItems =
        Array.from(
          primaryGroup.children
        ).map(
          function (item) {

            return item.cloneNode(
              true
            );

          }
        );

    }


    function buildMarquee() {

      var originalItems =
        section.__hhOriginalItems;


      if (
        !originalItems ||
        !originalItems.length
      ) {

        return;

      }


      track.style.animationPlayState =
        'paused';


      primaryGroup.innerHTML =
        '';


      cloneGroup.innerHTML =
        '';


      originalItems.forEach(
        function (originalItem) {

          var item =
            originalItem.cloneNode(
              true
            );


          primaryGroup.appendChild(
            item
          );

        }
      );


      var requiredWidth =
        viewport.clientWidth +
        200;


      var safety = 0;


      while (
        primaryGroup.scrollWidth <
          requiredWidth &&
        safety < 100
      ) {

        originalItems.forEach(
          function (originalItem) {

            var duplicate =
              originalItem.cloneNode(
                true
              );


            cleanClone(
              duplicate
            );


            duplicate.removeAttribute(
              'id'
            );


            duplicate.setAttribute(
              'aria-hidden',
              'true'
            );


            primaryGroup.appendChild(
              duplicate
            );

          }
        );


        safety++;

      }


      Array.from(
        primaryGroup.children
      ).forEach(
        function (item) {

          var duplicate =
            item.cloneNode(
              true
            );


          cleanClone(
            duplicate
          );


          duplicate.removeAttribute(
            'id'
          );


          duplicate.setAttribute(
            'aria-hidden',
            'true'
          );


          cloneGroup.appendChild(
            duplicate
          );

        }
      );


      void track.offsetWidth;


      track.style.animationPlayState =
        '';

    }


    buildMarquee();


    if (
      document.fonts &&
      document.fonts.ready
    ) {

      document.fonts.ready.then(
        function () {

          buildMarquee();

        }
      );

    }


    if (
      'ResizeObserver' in window
    ) {

      section.__hhResizeObserver =
        new ResizeObserver(
          function () {

            clearTimeout(
              section.__hhMarqueeResizeTimer
            );


            section.__hhMarqueeResizeTimer =
              setTimeout(
                function () {

                  buildMarquee();

                },
                150
              );

          }
        );


      section.__hhResizeObserver
        .observe(
          viewport
        );


    } else {


      section.__hhMarqueeResizeHandler =
        function () {

          clearTimeout(
            section.__hhMarqueeResizeTimer
          );


          section.__hhMarqueeResizeTimer =
            setTimeout(
              function () {

                buildMarquee();

              },
              150
            );

        };


      window.addEventListener(
        'resize',
        section.__hhMarqueeResizeHandler
      );

    }


    section.__hhRebuildMarquee =
      buildMarquee;

  }



  /* ==========================================================
     INIT SECTION
  ========================================================== */

  function initSection(section) {

    if (!section) return;


    initImageSequences(
      section
    );


    initMarquee(
      section
    );

  }



  /* ==========================================================
     CLEAN SECTION
  ========================================================== */

  function cleanupSection(
    section
  ) {

    if (!section) return;


    cleanupImageSequences(
      section
    );


    cleanupMarquee(
      section
    );

  }



  /* ==========================================================
     INIT ALL
  ========================================================== */

  function initAllHHSections() {

    document
      .querySelectorAll(
        '[data-hh-hero-section]'
      )
      .forEach(
        function (section) {

          initSection(
            section
          );

        }
      );

  }



  /* ==========================================================
     INITIAL LOAD
  ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllHHSections
    );


  } else {


    initAllHHSections();

  }



  /* ==========================================================
     SHOPIFY SECTION LOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section =
          event.target;


      } else {


        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        initSection(
          section
        );

      }

    }
  );



  /* ==========================================================
     SHOPIFY SECTION UNLOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section =
          event.target;


      } else {


        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        cleanupSection(
          section
        );

      }

    }
  );



  /* ==========================================================
     BLOCK SELECT
  ========================================================== */

  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var section =
        event.target.closest(
          '[data-hh-hero-section]'
        );


      if (!section) {

        return;

      }


      section.__hhCurrentSequence =
        null;


      updateActiveSequence(
        section
      );


      if (
        section.__hhRebuildMarquee
      ) {

        section.__hhRebuildMarquee();

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-landing-hero-new"] && !Shopify.designMode) return;
  try {
    

(function () {


  /* ==========================================================
     REMOVE SHOPIFY EDITOR ATTRIBUTES FROM GENERATED CLONES
  ========================================================== */

  function cleanClone(element) {

    if (!element) return;


    var elements = [
      element
    ].concat(
      Array.from(
        element.querySelectorAll('*')
      )
    );


    elements.forEach(function (node) {

      if (!node.attributes) return;


      Array.from(
        node.attributes
      ).forEach(function (attribute) {

        if (
          attribute.name.indexOf(
            'data-shopify-editor'
          ) === 0
        ) {

          node.removeAttribute(
            attribute.name
          );

        }

      });

    });

  }



  /* ==========================================================
     CLEANUP
  ========================================================== */

  function cleanupMarquee(section) {

    if (!section) return;


    if (section.__hhResizeObserver) {

      section.__hhResizeObserver.disconnect();

      section.__hhResizeObserver = null;

    }


    if (section.__hhResizeHandler) {

      window.removeEventListener(
        'resize',
        section.__hhResizeHandler
      );

      section.__hhResizeHandler = null;

    }


    if (section.__hhResizeTimer) {

      clearTimeout(
        section.__hhResizeTimer
      );

      section.__hhResizeTimer = null;

    }

  }



  /* ==========================================================
     INITIALIZE MARQUEE
  ========================================================== */

  function initMarquee(section) {

    if (!section) return;


    cleanupMarquee(section);



    var viewport =
      section.querySelector(
        '[data-hh-marquee-viewport]'
      );


    var track =
      section.querySelector(
        '[data-hh-marquee-track]'
      );


    var primaryGroup =
      section.querySelector(
        '[data-hh-marquee-primary]'
      );


    var cloneGroup =
      section.querySelector(
        '[data-hh-marquee-clone]'
      );


    if (
      !viewport ||
      !track ||
      !primaryGroup ||
      !cloneGroup
    ) {

      return;

    }



    /* ========================================================
       STORE ORIGINAL LIQUID BLOCKS

       Store them only one time.

       Generated duplicated items are never stored here.
    ======================================================== */

    if (!section.__hhOriginalItems) {

      section.__hhOriginalItems =
        Array.from(
          primaryGroup.children
        ).map(function (item) {

          return item.cloneNode(true);

        });

    }



    /* ========================================================
       BUILD PERFECT LOOP

       This only needs to build Group A (repeated until it
       overflows the viewport) and create an exact Group B
       clone. The -50% CSS animation handles the actual
       looping distance on its own, so there's no pixel
       measurement / custom-property step here anymore -
       one less thing that can silently fail.
    ======================================================== */

    function buildMarquee() {

      var originalItems =
        section.__hhOriginalItems;


      if (
        !originalItems ||
        !originalItems.length
      ) {

        return;

      }



      /*
        Stop while rebuilding so the swap is invisible.
      */

      track.style.animationPlayState = 'paused';



      /*
        Completely reset both groups.
      */

      primaryGroup.innerHTML = '';

      cloneGroup.innerHTML = '';



      /*
        Add one original Liquid set.
      */

      originalItems.forEach(
        function (originalItem) {

          var item =
            originalItem.cloneNode(true);


          primaryGroup.appendChild(
            item
          );

        }
      );



      /*
        Group A must always be wider than the
        visible marquee viewport.

        Using viewport width + buffer guarantees
        that we never expose empty space.
      */

      var requiredWidth =
        viewport.clientWidth + 200;



      var safety = 0;



      /*
        Repeat original Liquid block set until
        primary group is safely wider than viewport.
      */

      while (
        primaryGroup.scrollWidth <
          requiredWidth &&
        safety < 100
      ) {

        originalItems.forEach(
          function (originalItem) {

            var duplicate =
              originalItem.cloneNode(true);


            cleanClone(
              duplicate
            );


            duplicate.removeAttribute(
              'id'
            );


            duplicate.setAttribute(
              'aria-hidden',
              'true'
            );


            primaryGroup.appendChild(
              duplicate
            );

          }
        );


        safety++;

      }



      /*
        Create Group B.

        It must be EXACTLY identical to final Group A,
        since the CSS animation moves the track by -50%,
        which only produces a seamless loop when Group A
        and Group B are the same width.
      */

      Array.from(
        primaryGroup.children
      ).forEach(function (item) {

        var duplicate =
          item.cloneNode(true);


        cleanClone(
          duplicate
        );


        duplicate.removeAttribute(
          'id'
        );


        duplicate.setAttribute(
          'aria-hidden',
          'true'
        );


        cloneGroup.appendChild(
          duplicate
        );

      });



      /*
        Force layout before resuming the animation.
      */

      void track.offsetWidth;



      /*
        Resume (or start) the animation.
      */

      track.style.animationPlayState = '';

    }



    /* ========================================================
       INITIAL BUILD
    ======================================================== */

    buildMarquee();



    /* ========================================================
       REBUILD AFTER FONTS LOAD

       Important because font loading changes text width.
    ======================================================== */

    if (
      document.fonts &&
      document.fonts.ready
    ) {

      document.fonts.ready.then(
        function () {

          buildMarquee();

        }
      );

    }



    /* ========================================================
       RESIZE OBSERVER

       Watches actual 1440px viewport.

       Works on:
       - browser resize
       - responsive preview
       - Shopify Theme Editor resizing
    ======================================================== */

    if ('ResizeObserver' in window) {

      section.__hhResizeObserver =
        new ResizeObserver(
          function () {

            clearTimeout(
              section.__hhResizeTimer
            );


            section.__hhResizeTimer =
              setTimeout(
                function () {

                  buildMarquee();

                },
                150
              );

          }
        );


      section.__hhResizeObserver.observe(
        viewport
      );

    } else {


      section.__hhResizeHandler =
        function () {

          clearTimeout(
            section.__hhResizeTimer
          );


          section.__hhResizeTimer =
            setTimeout(
              function () {

                buildMarquee();

              },
              150
            );

        };


      window.addEventListener(
        'resize',
        section.__hhResizeHandler
      );

    }



    /*
      Save reference for Shopify editor.
    */

    section.__hhRebuildMarquee =
      buildMarquee;

  }



  /* ==========================================================
     INIT ALL SECTIONS
  ========================================================== */

  function initAllHHSections() {

    document
      .querySelectorAll(
        '[data-hh-hero-section]'
      )
      .forEach(
        function (section) {

          initMarquee(section);

        }
      );

  }



  /* ==========================================================
     DOCUMENT LOAD
  ========================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllHHSections
    );

  } else {

    initAllHHSections();

  }



  /* ==========================================================
     SHOPIFY SECTION LOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section = event.target;

      } else {

        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        initMarquee(
          section
        );

      }

    }
  );



  /* ==========================================================
     SHOPIFY SECTION UNLOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section = event.target;

      } else {

        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        cleanupMarquee(
          section
        );

      }

    }
  );



  /* ==========================================================
     SHOPIFY BLOCK SELECT
  ========================================================== */

  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var section =
        event.target.closest(
          '[data-hh-hero-section]'
        );


      if (
        section &&
        section.__hhRebuildMarquee
      ) {

        section.__hhRebuildMarquee();

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-landing-hero"] && !Shopify.designMode) return;
  try {
    

(function () {


  /* ==========================================================
     REMOVE SHOPIFY EDITOR ATTRIBUTES FROM GENERATED CLONES
  ========================================================== */

  function cleanClone(element) {

    if (!element) return;


    var elements = [
      element
    ].concat(
      Array.from(
        element.querySelectorAll('*')
      )
    );


    elements.forEach(function (node) {

      if (!node.attributes) return;


      Array.from(
        node.attributes
      ).forEach(function (attribute) {

        if (
          attribute.name.indexOf(
            'data-shopify-editor'
          ) === 0
        ) {

          node.removeAttribute(
            attribute.name
          );

        }

      });

    });

  }



  /* ==========================================================
     CLEANUP
  ========================================================== */

  function cleanupMarquee(section) {

    if (!section) return;


    if (section.__hhResizeObserver) {

      section.__hhResizeObserver.disconnect();

      section.__hhResizeObserver = null;

    }


    if (section.__hhResizeHandler) {

      window.removeEventListener(
        'resize',
        section.__hhResizeHandler
      );

      section.__hhResizeHandler = null;

    }


    if (section.__hhResizeTimer) {

      clearTimeout(
        section.__hhResizeTimer
      );

      section.__hhResizeTimer = null;

    }

  }



  /* ==========================================================
     INITIALIZE MARQUEE
  ========================================================== */

  function initMarquee(section) {

    if (!section) return;


    cleanupMarquee(section);



    var viewport =
      section.querySelector(
        '[data-hh-marquee-viewport]'
      );


    var track =
      section.querySelector(
        '[data-hh-marquee-track]'
      );


    var primaryGroup =
      section.querySelector(
        '[data-hh-marquee-primary]'
      );


    var cloneGroup =
      section.querySelector(
        '[data-hh-marquee-clone]'
      );


    if (
      !viewport ||
      !track ||
      !primaryGroup ||
      !cloneGroup
    ) {

      return;

    }



    /* ========================================================
       STORE ORIGINAL LIQUID BLOCKS

       Store them only one time.

       Generated duplicated items are never stored here.
    ======================================================== */

    if (!section.__hhOriginalItems) {

      section.__hhOriginalItems =
        Array.from(
          primaryGroup.children
        ).map(function (item) {

          return item.cloneNode(true);

        });

    }



    /* ========================================================
       BUILD PERFECT LOOP

       This only needs to build Group A (repeated until it
       overflows the viewport) and create an exact Group B
       clone. The -50% CSS animation handles the actual
       looping distance on its own, so there's no pixel
       measurement / custom-property step here anymore -
       one less thing that can silently fail.
    ======================================================== */

    function buildMarquee() {

      var originalItems =
        section.__hhOriginalItems;


      if (
        !originalItems ||
        !originalItems.length
      ) {

        return;

      }



      /*
        Stop while rebuilding so the swap is invisible.
      */

      track.style.animationPlayState = 'paused';



      /*
        Completely reset both groups.
      */

      primaryGroup.innerHTML = '';

      cloneGroup.innerHTML = '';



      /*
        Add one original Liquid set.
      */

      originalItems.forEach(
        function (originalItem) {

          var item =
            originalItem.cloneNode(true);


          primaryGroup.appendChild(
            item
          );

        }
      );



      /*
        Group A must always be wider than the
        visible marquee viewport.

        Using viewport width + buffer guarantees
        that we never expose empty space.
      */

      var requiredWidth =
        viewport.clientWidth + 200;



      var safety = 0;



      /*
        Repeat original Liquid block set until
        primary group is safely wider than viewport.
      */

      while (
        primaryGroup.scrollWidth <
          requiredWidth &&
        safety < 100
      ) {

        originalItems.forEach(
          function (originalItem) {

            var duplicate =
              originalItem.cloneNode(true);


            cleanClone(
              duplicate
            );


            duplicate.removeAttribute(
              'id'
            );


            duplicate.setAttribute(
              'aria-hidden',
              'true'
            );


            primaryGroup.appendChild(
              duplicate
            );

          }
        );


        safety++;

      }



      /*
        Create Group B.

        It must be EXACTLY identical to final Group A,
        since the CSS animation moves the track by -50%,
        which only produces a seamless loop when Group A
        and Group B are the same width.
      */

      Array.from(
        primaryGroup.children
      ).forEach(function (item) {

        var duplicate =
          item.cloneNode(true);


        cleanClone(
          duplicate
        );


        duplicate.removeAttribute(
          'id'
        );


        duplicate.setAttribute(
          'aria-hidden',
          'true'
        );


        cloneGroup.appendChild(
          duplicate
        );

      });



      /*
        Force layout before resuming the animation.
      */

      void track.offsetWidth;



      /*
        Resume (or start) the animation.
      */

      track.style.animationPlayState = '';

    }



    /* ========================================================
       INITIAL BUILD
    ======================================================== */

    buildMarquee();



    /* ========================================================
       REBUILD AFTER FONTS LOAD

       Important because font loading changes text width.
    ======================================================== */

    if (
      document.fonts &&
      document.fonts.ready
    ) {

      document.fonts.ready.then(
        function () {

          buildMarquee();

        }
      );

    }



    /* ========================================================
       RESIZE OBSERVER

       Watches actual 1440px viewport.

       Works on:
       - browser resize
       - responsive preview
       - Shopify Theme Editor resizing
    ======================================================== */

    if ('ResizeObserver' in window) {

      section.__hhResizeObserver =
        new ResizeObserver(
          function () {

            clearTimeout(
              section.__hhResizeTimer
            );


            section.__hhResizeTimer =
              setTimeout(
                function () {

                  buildMarquee();

                },
                150
              );

          }
        );


      section.__hhResizeObserver.observe(
        viewport
      );

    } else {


      section.__hhResizeHandler =
        function () {

          clearTimeout(
            section.__hhResizeTimer
          );


          section.__hhResizeTimer =
            setTimeout(
              function () {

                buildMarquee();

              },
              150
            );

        };


      window.addEventListener(
        'resize',
        section.__hhResizeHandler
      );

    }



    /*
      Save reference for Shopify editor.
    */

    section.__hhRebuildMarquee =
      buildMarquee;

  }



  /* ==========================================================
     INIT ALL SECTIONS
  ========================================================== */

  function initAllHHSections() {

    document
      .querySelectorAll(
        '[data-hh-hero-section]'
      )
      .forEach(
        function (section) {

          initMarquee(section);

        }
      );

  }



  /* ==========================================================
     DOCUMENT LOAD
  ========================================================== */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAllHHSections
    );

  } else {

    initAllHHSections();

  }



  /* ==========================================================
     SHOPIFY SECTION LOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section = event.target;

      } else {

        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        initMarquee(
          section
        );

      }

    }
  );



  /* ==========================================================
     SHOPIFY SECTION UNLOAD
  ========================================================== */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      var section = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-hh-hero-section]'
        )
      ) {

        section = event.target;

      } else {

        section =
          event.target.querySelector(
            '[data-hh-hero-section]'
          );

      }


      if (section) {

        cleanupMarquee(
          section
        );

      }

    }
  );



  /* ==========================================================
     SHOPIFY BLOCK SELECT
  ========================================================== */

  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var section =
        event.target.closest(
          '[data-hh-hero-section]'
        );


      if (
        section &&
        section.__hhRebuildMarquee
      ) {

        section.__hhRebuildMarquee();

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocao-landing-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initRunningBar(section) {

    if (!section) return;

    if (section.dataset.runningBarInitialized === 'true') return;
    section.dataset.runningBarInitialized = 'true';

    var track = section.querySelector('[data-running-bar-track]');
    var groups = section.querySelectorAll('[data-running-bar-group]');

    if (!track || groups.length < 2) return;

    var measureGroup = groups[0];

    /*
      Clone from the aria-hidden duplicate (not the "ORIGINAL GROUP"),
      since only the original carries block.shopify_attributes - cloning
      that into extra copies would give the theme editor multiple
      elements claiming the same block id.
    */
    var cloneSource = groups[1];

    function layout() {

      /* Reset to the 2 groups rendered by Liquid before re-measuring. */
      track.querySelectorAll('[data-running-bar-clone]').forEach(function (clone) {
        clone.remove();
      });

      var groupWidth = measureGroup.getBoundingClientRect().width;

      if (!groupWidth) return;

      /* Always cover at least 2 viewport widths so the loop never runs out of content. */
      var minTotalWidth = window.innerWidth * 2;
      var groupsPresent = track.querySelectorAll('[data-running-bar-group]').length;

      while (groupsPresent * groupWidth < minTotalWidth) {

        var clone = cloneSource.cloneNode(true);
        clone.setAttribute('data-running-bar-clone', '');
        track.appendChild(clone);

        groupsPresent++;

      }

      /* Shift by exactly one group's width - any extra clones just add coverage. */
      track.style.setProperty('--rb-shift', (-groupWidth) + 'px');

    }

    layout();

    if (section.__rbResizeHandler) {
      window.removeEventListener('resize', section.__rbResizeHandler);
    }

    var resizeTimer;
    section.__rbResizeHandler = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    };
    window.addEventListener('resize', section.__rbResizeHandler);

  }

  function initAll() {
    document.querySelectorAll('[data-running-bar-section]').forEach(initRunningBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var loadedSection =
      event.target.matches && event.target.matches('[data-running-bar-section]')
        ? event.target
        : event.target.querySelector('[data-running-bar-section]');
    if (!loadedSection) return;
    loadedSection.dataset.runningBarInitialized = 'false';
    initRunningBar(loadedSection);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var unloadedSection =
      event.target.matches && event.target.matches('[data-running-bar-section]')
        ? event.target
        : event.target.querySelector('[data-running-bar-section]');
    if (!unloadedSection || !unloadedSection.__rbResizeHandler) return;
    window.removeEventListener('resize', unloadedSection.__rbResizeHandler);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {

    const section = document.querySelector(
      '[data-ocoa-faq]'
    );

    if (!section) return;


    /*
     * ======================================================
     * INITIALIZE FAQ
     * ======================================================
     */

    const initOcoaFaq = (targetSection) => {

      if (targetSection.dataset.initialized === 'true') {
        return;
      }

      targetSection.dataset.initialized = 'true';


      const tabs = targetSection.querySelectorAll(
        '[data-faq-tab]'
      );

      const items = targetSection.querySelectorAll(
        '[data-faq-item]'
      );


      /*
       * ====================================================
       * CLOSE ACCORDION
       * ====================================================
       */

      const closeItem = (item) => {

        if (!item) return;


        const button = item.querySelector(
          '.ocoa-faq__question'
        );


        const wrapper = item.querySelector(
          '.ocoa-faq__answer-wrapper'
        );


        item.classList.remove('is-open');


        if (button) {
          button.setAttribute(
            'aria-expanded',
            'false'
          );
        }


        if (wrapper) {
          wrapper.style.maxHeight = '0px';
        }

      };


      /*
       * ====================================================
       * OPEN ACCORDION
       * ====================================================
       */

      const openItem = (item) => {

        if (!item) return;


        const button = item.querySelector(
          '.ocoa-faq__question'
        );


        const wrapper = item.querySelector(
          '.ocoa-faq__answer-wrapper'
        );


        item.classList.add('is-open');


        if (button) {
          button.setAttribute(
            'aria-expanded',
            'true'
          );
        }


        if (wrapper) {
          wrapper.style.maxHeight =
            wrapper.scrollHeight + 'px';
        }

      };


      /*
       * ====================================================
       * SWITCH TAB
       * ====================================================
       */

      const activateTab = (selectedTab) => {

        const selectedCategory =
          selectedTab.dataset.faqTab;


        /*
         * Update tab states
         */

        tabs.forEach((tab) => {

          const active =
            tab === selectedTab;


          tab.classList.toggle(
            'is-active',
            active
          );


          tab.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

        });


        /*
         * Filter accordion items
         */

        items.forEach((item) => {

          closeItem(item);


          const matchingCategory =
            item.dataset.category === selectedCategory;


          item.classList.toggle(
            'is-hidden',
            !matchingCategory
          );

        });

      };


      /*
       * ====================================================
       * TAB CLICK
       * ====================================================
       */

      tabs.forEach((tab) => {

        tab.addEventListener(
          'click',
          () => {
            activateTab(tab);
          }
        );

      });


      /*
       * ====================================================
       * ACCORDION CLICK
       * ====================================================
       */

      items.forEach((item) => {

        const button = item.querySelector(
          '.ocoa-faq__question'
        );


        if (!button) return;


        button.addEventListener(
          'click',
          () => {

            const currentlyOpen =
              item.classList.contains('is-open');


            /*
             * Close all other items
             */

            items.forEach((otherItem) => {

              if (otherItem !== item) {
                closeItem(otherItem);
              }

            });


            /*
             * Toggle clicked item
             */

            if (currentlyOpen) {

              closeItem(item);

            } else {

              openItem(item);

            }

          }
        );

      });


      /*
       * ====================================================
       * HANDLE WINDOW RESIZE
       * ====================================================
       */

      window.addEventListener(
        'resize',
        () => {

          items.forEach((item) => {

            if (!item.classList.contains('is-open')) {
              return;
            }


            const wrapper = item.querySelector(
              '.ocoa-faq__answer-wrapper'
            );


            if (wrapper) {
              wrapper.style.maxHeight =
                wrapper.scrollHeight + 'px';
            }

          });

        }
      );

    };


    initOcoaFaq(section);


    /*
     * ========================================================
     * SHOPIFY THEME EDITOR
     * ========================================================
     */

    document.addEventListener(
      'shopify:section:load',
      (event) => {

        const loadedSection =
          event.target.querySelector('[data-ocoa-faq]') ||
          (
            event.target.matches &&
            event.target.matches('[data-ocoa-faq]')
              ? event.target
              : null
          );

        if (!loadedSection) return;

        loadedSection.dataset.initialized = 'false';
        initOcoaFaq(loadedSection);
      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
    window.PromoProductHero = window.PromoProductHero || {};

    if (!window.PromoProductHero.init) {
      window.PromoProductHero.init = (section) => {
        if (!section || section.dataset.pphInitialized === 'true') return;

        section.dataset.pphInitialized = 'true';

        const slider = section.querySelector('[data-pph-slider]');
        if (!slider) return;

        const slides = Array.from(section.querySelectorAll('[data-pph-slide]'));
        const indicators = Array.from(section.querySelectorAll('[data-pph-indicator]'));
        const prevButton = section.querySelector('[data-pph-prev]');
        const nextButton = section.querySelector('[data-pph-next]');

        if (!slides.length) return;

        const autoplayEnabled = slider.dataset.autoplay === 'true';
        const autoplaySpeed = Number(slider.dataset.autoplaySpeed) || 4000;
        const infiniteLoop = slider.dataset.loop === 'true';
        const swipeEnabled = slider.dataset.swipe === 'true';
        const pauseOnHover = slider.dataset.pauseHover === 'true';

        let activeIndex = 0;
        let autoplayTimer = null;
        let pointerStartX = null;
        let didSwipe = false;

        const normalizeIndex = (index) => {
          if (infiniteLoop) {
            return (index + slides.length) % slides.length;
          }

          return Math.max(0, Math.min(index, slides.length - 1));
        };

        const updateArrowState = () => {
          if (!prevButton || !nextButton) return;

          if (infiniteLoop) {
            prevButton.disabled = false;
            nextButton.disabled = false;
            return;
          }

          prevButton.disabled = activeIndex === 0;
          nextButton.disabled = activeIndex === slides.length - 1;
        };

        const showSlide = (index) => {
          activeIndex = normalizeIndex(index);

          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('is-active', slideIndex === activeIndex);
          });

          indicators.forEach((indicator, indicatorIndex) => {
            const isActive = indicatorIndex === activeIndex;
            indicator.classList.toggle('is-active', isActive);
            indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
          });

          updateArrowState();
        };

        const stopAutoplay = () => {
          if (!autoplayTimer) return;
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        const nextSlide = () => {
          if (!infiniteLoop && activeIndex >= slides.length - 1) {
            stopAutoplay();
            return;
          }

          showSlide(activeIndex + 1);
        };

        const previousSlide = () => {
          showSlide(activeIndex - 1);
        };

        const startAutoplay = () => {
          stopAutoplay();

          if (!autoplayEnabled || slides.length <= 1) return;
          if (!infiniteLoop && activeIndex >= slides.length - 1) return;

          autoplayTimer = setInterval(nextSlide, autoplaySpeed);
        };

        indicators.forEach((indicator) => {
          indicator.addEventListener('click', () => {
            showSlide(Number(indicator.dataset.slideIndex));
            startAutoplay();
          });

          indicator.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
            event.preventDefault();
            showSlide(Number(indicator.dataset.slideIndex));
            startAutoplay();
          });
        });

        prevButton?.addEventListener('click', () => {
          previousSlide();
          startAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          nextSlide();
          startAutoplay();
        });

        if (pauseOnHover && autoplayEnabled) {
          slider.addEventListener('mouseenter', stopAutoplay);
          slider.addEventListener('mouseleave', startAutoplay);
        }
        
        if (swipeEnabled && slides.length > 1) {
          slider.style.touchAction = 'pan-y';

          slider.addEventListener('pointerdown', (event) => {
            pointerStartX = event.clientX;
            didSwipe = false;
          });

          slider.addEventListener('pointerup', (event) => {
            if (pointerStartX === null) return;

            const distance = event.clientX - pointerStartX;
            pointerStartX = null;

            if (Math.abs(distance) < 40) return;

            didSwipe = true;

            if (distance < 0) {
              nextSlide();
            } else {
              previousSlide();
            }

            startAutoplay();
          });

          slider.addEventListener('pointercancel', () => {
            pointerStartX = null;
          });

          slider.addEventListener(
            'click',
            (event) => {
              if (!didSwipe) return;
              event.preventDefault();
              event.stopPropagation();
              didSwipe = false;
            },
            true
          );
        }

        if (slides.length > 1) {
  slider.addEventListener('keydown', (event) => {

    // Desktop only
    if (window.innerWidth <= 940) return;

    // Don't interfere with form controls
    if (event.target.closest('input, select, textarea')) return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();

      previousSlide();
      startAutoplay();
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();

      nextSlide();
      startAutoplay();
    }

  });
}

        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        section.__pphShowSlide = showSlide;
        section.__pphCleanup = () => {
          stopAutoplay();
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };

        showSlide(0);
        startAutoplay();
      };
    }

    if (!window.PromoProductHero.editorEventsBound) {
      window.PromoProductHero.editorEventsBound = true;

      document.addEventListener('shopify:section:load', (event) => {
        const section =
          event.target.matches?.('[data-pph-section]')
            ? event.target
            : event.target.querySelector?.('[data-pph-section]');

        if (section) {
          window.PromoProductHero.init(section);
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const section =
          event.target.matches?.('[data-pph-section]')
            ? event.target
            : event.target.querySelector?.('[data-pph-section]');

        section?.__pphCleanup?.();
      });

      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest?.('[data-pph-slide]');
        const section = block?.closest?.('[data-pph-section]');

        if (!block || !section || !section.__pphShowSlide) return;

        section.__pphShowSlide(Number(block.dataset.slideIndex));
      });
    }

    document.querySelectorAll('[data-pph-section]').forEach((section) => {
      window.PromoProductHero.init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-ingredients"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ocoaIngredientsSliderRegistry';
    const editorBoundKey = '__ocoaIngredientsSliderEditorBound';

    window[registryKey] = window[registryKey] || new Map();
    const registry = window[registryKey];

    const initIngredientsSlider = (section) => {
      if (!section) return;

      const existing = registry.get(section.id);

      if (existing) {
        if (existing.section === section) return;
        existing.cleanup();
      }

      const slider = section.querySelector('[data-ing-slider]');
      const track = section.querySelector('[data-ing-track]');
      const slides = Array.from(section.querySelectorAll('[data-ing-slide]'));
      const prevButton = section.querySelector('[data-ing-prev]');
      const nextButton = section.querySelector('[data-ing-next]');

      if (!slider || !track || !slides.length) return;

      const infiniteLoop = section.dataset.infiniteLoop === 'true';
      const autoplayEnabled = section.dataset.autoplay === 'true';
      const autoplaySpeed = Math.max(
        1000,
        parseInt(section.dataset.autoplaySpeed || '5000', 10)
      );
      const desktopDragEnabled = section.dataset.dragDesktop !== 'false';

      const cleanupCallbacks = [];
      let resizeObserver = null;
      let autoplayTimer = null;
      let scrollFrame = null;
      let restartTimer = null;

      const listen = (target, eventName, handler, options) => {
        target.addEventListener(eventName, handler, options);
        cleanupCallbacks.push(() => {
          target.removeEventListener(eventName, handler, options);
        });
      };

      const getGap = () => {
        const styles = window.getComputedStyle(track);

        return (
          parseFloat(styles.gap) ||
          parseFloat(styles.columnGap) ||
          0
        );
      };

      const getSlideStep = () => {
        if (!slides[0]) return 0;

        return slides[0].getBoundingClientRect().width + getGap();
      };

      const getMaxScroll = () => {
        return Math.max(0, slider.scrollWidth - slider.clientWidth);
      };

      const updateButtons = () => {
        const maxScroll = getMaxScroll();
        const hasOverflow = maxScroll > 2;

        if (prevButton) {
          prevButton.disabled = !hasOverflow || (
            !infiniteLoop && slider.scrollLeft <= 2
          );
        }

        if (nextButton) {
          nextButton.disabled = !hasOverflow || (
            !infiniteLoop && slider.scrollLeft >= maxScroll - 2
          );
        }
      };

      const goNext = () => {
        const step = getSlideStep();
        const maxScroll = getMaxScroll();

        if (step <= 0 || maxScroll <= 2) return;

        if (infiniteLoop && slider.scrollLeft >= maxScroll - 2) {
          slider.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
          return;
        }

        slider.scrollBy({
          left: step,
          behavior: 'smooth'
        });
      };

      const goPrev = () => {
        const step = getSlideStep();
        const maxScroll = getMaxScroll();

        if (step <= 0 || maxScroll <= 2) return;

        if (infiniteLoop && slider.scrollLeft <= 2) {
          slider.scrollTo({
            left: maxScroll,
            behavior: 'smooth'
          });
          return;
        }

        slider.scrollBy({
          left: -step,
          behavior: 'smooth'
        });
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }

        if (restartTimer) {
          window.clearTimeout(restartTimer);
          restartTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (!autoplayEnabled || slides.length <= 1) return;

        autoplayTimer = window.setInterval(() => {
          if (document.hidden) return;
          goNext();
        }, autoplaySpeed);
      };

      const restartAutoplaySoon = () => {
        if (!autoplayEnabled) return;

        stopAutoplay();

        restartTimer = window.setTimeout(() => {
          startAutoplay();
        }, Math.min(autoplaySpeed, 2500));
      };

      if (nextButton) {
        listen(nextButton, 'click', () => {
          goNext();
          restartAutoplaySoon();
        });
      }

      if (prevButton) {
        listen(prevButton, 'click', () => {
          goPrev();
          restartAutoplaySoon();
        });
      }

      listen(
        slider,
        'scroll',
        () => {
          if (scrollFrame) {
            cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = requestAnimationFrame(() => {
            updateButtons();
            scrollFrame = null;
          });
        },
        { passive: true }
      );

      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let hasDragged = false;

      listen(slider, 'pointerdown', (event) => {
        if (!desktopDragEnabled) return;

        if (
          event.pointerType &&
          event.pointerType !== 'mouse'
        ) {
          return;
        }

        if (
          event.button !== undefined &&
          event.button !== 0
        ) {
          return;
        }

        isDragging = true;
        hasDragged = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = slider.scrollLeft;

        slider.classList.add('is-dragging');
        stopAutoplay();

        try {
          slider.setPointerCapture(event.pointerId);
        } catch (error) {}
      });

      listen(slider, 'pointermove', (event) => {
        if (!isDragging) return;

        const movement = event.clientX - dragStartX;

        if (Math.abs(movement) > 4) {
          hasDragged = true;
        }

        slider.scrollLeft = dragStartScrollLeft - movement;
        event.preventDefault();
      });

      const endDrag = (event) => {
        if (!isDragging) return;

        isDragging = false;
        slider.classList.remove('is-dragging');

        try {
          slider.releasePointerCapture(event.pointerId);
        } catch (error) {}

        const step = getSlideStep();

        if (step > 0) {
          const index = Math.round(slider.scrollLeft / step);
          const target = Math.min(index * step, getMaxScroll());

          slider.scrollTo({
            left: target,
            behavior: 'smooth'
          });
        }

        restartAutoplaySoon();
      };

      listen(slider, 'pointerup', endDrag);
      listen(slider, 'pointercancel', endDrag);

      listen(slider, 'pointerleave', (event) => {
        if (
          isDragging &&
          (
            !event.pointerType ||
            event.pointerType === 'mouse'
          )
        ) {
          endDrag(event);
        }
      });

      listen(
        slider,
        'click',
        (event) => {
          if (!hasDragged) return;

          event.preventDefault();
          event.stopPropagation();
          hasDragged = false;
        },
        true
      );

      listen(slider, 'keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goNext();
          restartAutoplaySoon();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goPrev();
          restartAutoplaySoon();
        }
      });

      listen(slider, 'touchstart', stopAutoplay, { passive: true });
      listen(slider, 'touchend', restartAutoplaySoon, { passive: true });

      const handleResize = () => {
        updateButtons();
      };

      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(slider);
        resizeObserver.observe(track);
      }

      listen(window, 'resize', handleResize, { passive: true });

      listen(section, 'shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-ing-slide]');

        if (!selectedSlide) return;

        const index = slides.indexOf(selectedSlide);

        if (index < 0) return;

        const step = getSlideStep();

        slider.scrollTo({
          left: Math.min(index * step, getMaxScroll()),
          behavior: 'smooth'
        });
      });

      updateButtons();
      startAutoplay();

      const cleanup = () => {
        stopAutoplay();

        if (scrollFrame) {
          cancelAnimationFrame(scrollFrame);
        }

        if (resizeObserver) {
          resizeObserver.disconnect();
        }

        cleanupCallbacks.forEach((callback) => callback());

        if (registry.get(section.id)?.section === section) {
          registry.delete(section.id);
        }
      };

      registry.set(section.id, {
        section,
        cleanup
      });
    };

    document.querySelectorAll('.ing-section').forEach(initIngredientsSlider);

    if (!window[editorBoundKey]) {
      window[editorBoundKey] = true;

      document.addEventListener('shopify:section:load', (event) => {
        const loadedSections = [];

        if (event.target.matches?.('.ing-section')) {
          loadedSections.push(event.target);
        }

        event.target
          .querySelectorAll?.('.ing-section')
          .forEach((section) => loadedSections.push(section));

        loadedSections.forEach(initIngredientsSlider);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const unloadedSections = [];

        if (event.target.matches?.('.ing-section')) {
          unloadedSections.push(event.target);
        }

        event.target
          .querySelectorAll?.('.ing-section')
          .forEach((section) => unloadedSections.push(section));

        unloadedSections.forEach((section) => {
          registry.get(section.id)?.cleanup();
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-inside-accordian"] && !Shopify.designMode) return;
  try {
    
  (() => {

    function initWhatsInsideSection(section) {

      if (!section || section.dataset.wiInitialized === 'true') return;

      section.dataset.wiInitialized = 'true';

      const accordionItems = section.querySelectorAll('.wi-accordion-item');

      accordionItems.forEach((item) => {

        const trigger = item.querySelector('.wi-accordion-trigger');
        const panel = item.querySelector('.wi-accordion-panel');

        if (!trigger || !panel) return;


        trigger.addEventListener('click', () => {

          const isOpen = trigger.getAttribute('aria-expanded') === 'true';


          /*
            Close all other accordion items
          */

          accordionItems.forEach((otherItem) => {

            const otherTrigger = otherItem.querySelector('.wi-accordion-trigger');
            const otherPanel = otherItem.querySelector('.wi-accordion-panel');

            if (!otherTrigger || !otherPanel) return;


            if (otherItem !== item) {

              otherTrigger.setAttribute('aria-expanded', 'false');
              otherPanel.hidden = true;
              otherItem.classList.remove('is-open');

            }

          });


          /*
            Toggle clicked accordion
          */

          if (isOpen) {

            trigger.setAttribute('aria-expanded', 'false');
            panel.hidden = true;
            item.classList.remove('is-open');

          } else {

            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            item.classList.add('is-open');

          }

        });

      });

    }


    document.querySelectorAll('.wi-section').forEach(initWhatsInsideSection);


    /*
      Reinitialize when Shopify theme editor
      reloads the section.
    */

    document.addEventListener('shopify:section:load', function(event) {

      const loadedSection =
        event.target.matches && event.target.matches('.wi-section')
          ? event.target
          : event.target.querySelector && event.target.querySelector('.wi-section');

      if (loadedSection) {

        loadedSection.dataset.wiInitialized = '';
        initWhatsInsideSection(loadedSection);

      }

    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-pd-card"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-shop-range]';

  const getSection = target => {
    if (!target) return null;
    if (target.matches && target.matches(selector)) return target;
    return target.querySelector ? target.querySelector(selector) : null;
  };

  const init = section => {
    if (!section || section.dataset.shopRangeInitialized === 'true') return;

    section.dataset.shopRangeInitialized = 'true';

    const addLabel = section.dataset.addLabel || 'ADD TO BAG';
    const soldLabel = section.dataset.soldLabel || 'SOLD OUT';
    const cartAddUrl = section.dataset.cartAddUrl || '/cart/add.js';
    const cartUrl = section.dataset.cartUrl || '/cart';

    const cleanups = [];

    const on = (element, type, handler, options) => {
      if (!element) return;

      element.addEventListener(type, handler, options);

      cleanups.push(() => {
        element.removeEventListener(type, handler, options);
      });
    };

    /* ============================================================
       PRODUCT / VARIANT DATA
    ============================================================ */

    const getMeta = (card, variantId) => {
      if (!card._srVariants) {
        const node = card.querySelector('[data-variant-data]');

        try {
          const list = node ? JSON.parse(node.textContent) : [];

          card._srVariants = new Map(
            list.map(item => [String(item.id), item])
          );
        } catch (error) {
          console.error('Shop The Range - variant data error:', error);
          card._srVariants = new Map();
        }
      }

      return card._srVariants.get(String(variantId));
    };

    /* ============================================================
       PURCHASE TYPE
    ============================================================ */

    const setPurchaseMode = (card, mode) => {
      const toggle = card.querySelector('[data-purchase-toggle]');
      const sub = card.querySelector('[data-purchase-sub]');
      const one = card.querySelector('[data-purchase-one]');
      const input = card.querySelector('[data-cart-selling-plan]');

      const canSubscribe = Boolean(
        toggle &&
        sub &&
        !sub.classList.contains('is-hidden') &&
        sub.dataset.planId
      );

      const useSubscription =
        mode === 'sub' &&
        canSubscribe;

      card.dataset.purchaseMode =
        useSubscription ? 'sub' : 'one';

      if (sub) {
        sub.classList.toggle(
          'is-active',
          useSubscription
        );

        sub.setAttribute(
          'aria-pressed',
          useSubscription ? 'true' : 'false'
        );
      }

      if (one) {
        one.classList.toggle(
          'is-active',
          !useSubscription
        );

        one.setAttribute(
          'aria-pressed',
          useSubscription ? 'false' : 'true'
        );
      }

      if (input) {
        input.value =
          useSubscription && sub
            ? sub.dataset.planId
            : '';

        input.disabled = !useSubscription;
      }
    };

    const updatePurchase = (card, meta) => {
      const toggle = card.querySelector(
        '[data-purchase-toggle]'
      );

      const staticRow = card.querySelector(
        '[data-purchase-static]'
      );

      const sub = card.querySelector(
        '[data-purchase-sub]'
      );

      const one = card.querySelector(
        '[data-purchase-one]'
      );

      if (toggle) {
        toggle.classList.remove('is-hidden');
      }

      if (staticRow) {
        staticRow.classList.add('is-hidden');
      }

      if (
        meta &&
        meta.hasPlans &&
        meta.planId
      ) {
        if (toggle) {
          toggle.classList.remove(
            'is-one-time-only'
          );
        }

        if (sub) {
          sub.classList.remove('is-hidden');

          sub.dataset.planId =
            String(meta.planId);

          sub.dataset.price =
            meta.subPrice || '';
        }

        if (one) {
          one.dataset.price =
            meta.price || '';
        }

        setPurchaseMode(
          card,
          card.dataset.purchasePreference === 'one'
            ? 'one'
            : 'sub'
        );

        return;
      }

      if (toggle) {
        toggle.classList.add(
          'is-one-time-only'
        );
      }

      if (sub) {
        sub.classList.add('is-hidden');
        sub.classList.remove('is-active');

        sub.dataset.planId = '';
        sub.dataset.price = '';

        sub.setAttribute(
          'aria-pressed',
          'false'
        );
      }

      if (one) {
        one.dataset.price =
          meta
            ? meta.price || ''
            : '';
      }

      setPurchaseMode(card, 'one');
    };

    /* ============================================================
       PRICE
    ============================================================ */

    const updatePrice = card => {
      const price = card.querySelector(
        '[data-atc-price]'
      );

      if (!price) return;

      const mode =
        card.dataset.purchaseMode || 'one';

      const modeButton =
        card.querySelector(
          mode === 'sub'
            ? '[data-purchase-sub]'
            : '[data-purchase-one]'
        );

      const modePrice =
        modeButton
          ? modeButton.dataset.price
          : '';

      if (modePrice) {
        price.textContent = modePrice;
        return;
      }

      const meta = getMeta(
        card,
        card.dataset.currentVariant
      );

      if (meta && meta.price) {
        price.textContent = meta.price;
      }
    };

    /* ============================================================
       AVAILABILITY
    ============================================================ */

    const updateAvailability = (
      card,
      available
    ) => {
      const button = card.querySelector(
        '[data-add-to-bag]'
      );

      const label = card.querySelector(
        '[data-atc-label]'
      );

      const dot = card.querySelector(
        '[data-atc-dot]'
      );

      const price = card.querySelector(
        '[data-atc-price]'
      );

      if (!button || !label) return;

      button.disabled = !available;

      label.textContent =
        available
          ? addLabel
          : soldLabel;

      if (dot) {
        dot.hidden = !available;
      }

      if (price) {
        price.hidden = !available;
      }
    };

    /* ============================================================
       IMAGE
    ============================================================ */

    const updateImage = (card, meta) => {
      if (!meta || !meta.image) return;

      const image = card.querySelector(
        '[data-product-image]'
      );

      if (!image) return;

      image.src = meta.image;

      if (meta.srcset) {
        image.srcset = meta.srcset;
      } else {
        image.removeAttribute('srcset');
      }

      if (meta.width) {
        image.width = meta.width;
      }

      if (meta.height) {
        image.height = meta.height;
      }

      image.alt = meta.alt || '';
    };

    /* ============================================================
       SELECT VARIANT
    ============================================================ */

    const selectVariant = (
      card,
      variantId
    ) => {
      const meta = getMeta(
        card,
        variantId
      );

      if (!meta) return;

      variantId = String(variantId);

      card.dataset.currentVariant =
        variantId;

      const input = card.querySelector(
        '[data-cart-variant-id]'
      );

      if (input) {
        input.value = variantId;
      }

      card
        .querySelectorAll(
          '[data-variant-button]'
        )
        .forEach(button => {
          const active =
            button.dataset.variantId ===
            variantId;

          button.classList.toggle(
            'is-active',
            active
          );

          button.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });

      const select = card.querySelector(
        '[data-variant-select]'
      );

      if (
        select &&
        select.value !== variantId
      ) {
        select.value = variantId;
      }

      updatePurchase(card, meta);
      updatePrice(card);

      updateAvailability(
        card,
        Boolean(meta.available)
      );

      updateImage(card, meta);
    };

    /* ============================================================
       INITIALIZE CARDS
    ============================================================ */

    section
      .querySelectorAll(
        '[data-product-card]'
      )
      .forEach(card => {
        card.dataset.purchasePreference =
          card.dataset.purchasePreference ||
          'sub';

        const meta = getMeta(
          card,
          card.dataset.currentVariant
        );

        updatePurchase(card, meta);
        updatePrice(card);
      });

    /* ============================================================
       VARIANT / PURCHASE CLICKS
    ============================================================ */

    on(section, 'click', event => {
      const variant =
        event.target.closest(
          '[data-variant-button]'
        );

      if (
        variant &&
        !variant.disabled
      ) {
        const card =
          variant.closest(
            '[data-product-card]'
          );

        if (card) {
          selectVariant(
            card,
            variant.dataset.variantId
          );
        }

        return;
      }

      const purchase =
        event.target.closest(
          '[data-purchase-sub], [data-purchase-one]'
        );

      if (!purchase) return;

      const card =
        purchase.closest(
          '[data-product-card]'
        );

      if (!card) return;

      if (
        purchase.matches(
          '[data-purchase-sub]'
        )
      ) {
        if (!purchase.dataset.planId) {
          return;
        }

        card.dataset.purchasePreference =
          'sub';

        setPurchaseMode(card, 'sub');
      } else {
        card.dataset.purchasePreference =
          'one';

        setPurchaseMode(card, 'one');
      }

      updatePrice(card);
    });

    /* ============================================================
       VARIANT SELECT
    ============================================================ */

    on(section, 'change', event => {
      if (
        !event.target.matches(
          '[data-variant-select]'
        )
      ) {
        return;
      }

      const card =
        event.target.closest(
          '[data-product-card]'
        );

      if (card) {
        selectVariant(
          card,
          event.target.value
        );
      }
    });

    /* ============================================================
       ADD TO CART
    ============================================================ */

    on(section, 'submit', async event => {
      const form =
        event.target.closest(
          '[data-shop-range-form]'
        );

      if (!form) return;

      event.preventDefault();

      const addButton =
        form.querySelector(
          '[data-add-to-bag]'
        );

      if (
        !addButton ||
        addButton.disabled
      ) {
        return;
      }

      addButton.disabled = true;
      addButton.classList.add(
        'is-loading'
      );

      const modalCart = Boolean(
        window.theme &&
        window.theme.settings &&
        window.theme.settings.cart_type ===
          'modal'
      );

      try {
        const formData =
          new FormData(form);

        if (modalCart) {
          formData.append(
            'sections',
            'cart-items,cart-footer,cart-item-count'
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );
        }

        const endpoint =
          (
            window.theme &&
            window.theme.routes &&
            window.theme.routes.cart_add_url
          ) ||
          cartAddUrl;

        const response =
          await fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',

            headers: {
              'X-Requested-With':
                'XMLHttpRequest',
              Accept:
                'application/javascript'
            },

            body: formData
          });

        const result =
          await response.json();

        if (
          !response.ok ||
          result.status
        ) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add product to cart.'
          );
        }

        if (modalCart) {
          document.body.dispatchEvent(
            new CustomEvent(
              'shapes:modalcart:afteradditem',
              {
                bubbles: true,
                detail: {
                  response: result
                }
              }
            )
          );

          if (
            window.Alpine &&
            result.sections &&
            result.sections[
              'cart-item-count'
            ]
          ) {
            try {
              const doc =
                new DOMParser()
                  .parseFromString(
                    result.sections[
                      'cart-item-count'
                    ],
                    'text/html'
                  );

              const element =
                doc.body.firstElementChild;

              const count =
                element
                  ? parseInt(
                      element.innerText.trim(),
                      10
                    )
                  : NaN;

              if (
                !Number.isNaN(count)
              ) {
                window.Alpine.store(
                  'cart_count'
                ).count = count;
              }
            } catch (error) {
              console.warn(
                'Shop The Range - could not sync cart count:',
                error
              );
            }
          }
        } else {
          window.location.href =
            (
              window.theme &&
              window.theme.routes &&
              window.theme.routes.cart_url
            ) ||
            cartUrl;
        }
      } catch (error) {
        console.error(
          'Shop The Range - Add to cart error:',
          error
        );

        alert(error.message);
      } finally {
        addButton.disabled = false;

        addButton.classList.remove(
          'is-loading'
        );
      }
    });

    /* ============================================================
       SLIDER
    ============================================================ */

    const slider =
      section.querySelector(
        '[data-shop-range-slider]'
      );

    const prev =
      section.querySelector(
        '[data-slider-prev]'
      );

    const next =
      section.querySelector(
        '[data-slider-next]'
      );

    const pagination =
      section.querySelector(
        '[data-slider-pagination]'
      );

    let timer = null;
    let dragging = false;
    let startX = 0;
    let startScroll = 0;

    let scrollRaf = null;
    let resizeTimer = null;

    const cards = () =>
      slider
        ? Array.from(
            slider.querySelectorAll(
              '[data-product-card]'
            )
          )
        : [];

    const maxScroll = () =>
      slider
        ? Math.max(
            0,
            slider.scrollWidth -
              slider.clientWidth
          )
        : 0;

    const atStart = () =>
      !slider ||
      slider.scrollLeft <= 2;

    const atEnd = () =>
      !slider ||
      slider.scrollLeft >=
        maxScroll() - 2;

    /* ============================================================
       SLIDER STEP
    ============================================================ */

    const step = () => {
      const first = cards()[0];

      if (!first || !slider) {
        return slider
          ? slider.clientWidth
          : 0;
      }

      const computed =
        getComputedStyle(slider);

      const gap =
        parseFloat(
          computed.columnGap ||
          computed.gap ||
          '0'
        ) || 0;

      return (
        first.getBoundingClientRect()
          .width + gap
      );
    };

    /* ============================================================
       AUTOPLAY
    ============================================================ */

    const stopAutoplay = () => {
      if (!timer) return;

      window.clearInterval(timer);
      timer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();

      if (
        !slider ||
        section.dataset.autoplay !==
          'true' ||
        document.hidden ||
        maxScroll() <= 2
      ) {
        return;
      }

      const delay = Math.max(
        2000,
        parseInt(
          section.dataset
            .autoplaySpeed ||
            '5000',
          10
        )
      );

      timer =
        window.setInterval(() => {
          move(1);
        }, delay);
    };

    /* ============================================================
       ARROWS
    ============================================================ */

    const updateArrows = () => {
      const hasOverflow =
        Boolean(
          slider &&
          maxScroll() > 2
        );

      const loop =
        section.dataset.loop ===
        'true';

      if (prev) {
        prev.disabled =
          !hasOverflow ||
          (!loop && atStart());
      }

      if (next) {
        next.disabled =
          !hasOverflow ||
          (!loop && atEnd());
      }
    };

    /* ============================================================
       PAGINATION
    ============================================================ */

    const getPaginationCount = () => {
      if (
        !slider ||
        maxScroll() <= 2
      ) {
        return 1;
      }

      const slideStep = step();

      if (slideStep <= 0) {
        return 1;
      }

      return Math.max(
        1,
        Math.ceil(
          maxScroll() /
            slideStep
        ) + 1
      );
    };

    const getActivePaginationIndex =
      () => {
        if (
          !slider ||
          maxScroll() <= 2
        ) {
          return 0;
        }

        const slideStep = step();

        if (slideStep <= 0) {
          return 0;
        }

        const count =
          getPaginationCount();

        return Math.max(
          0,
          Math.min(
            count - 1,
            Math.round(
              slider.scrollLeft /
                slideStep
            )
          )
        );
      };

    const updatePagination = () => {
      if (!pagination) return;

      const dots =
        pagination.querySelectorAll(
          '[data-pagination-dot]'
        );

      if (!dots.length) return;

      const activeIndex =
        getActivePaginationIndex();

      dots.forEach(
        (dot, index) => {
          const active =
            index === activeIndex;

          dot.classList.toggle(
            'is-active',
            active
          );

          if (active) {
            dot.setAttribute(
              'aria-current',
              'true'
            );
          } else {
            dot.removeAttribute(
              'aria-current'
            );
          }
        }
      );
    };

    const buildPagination = () => {
      if (!pagination) return;

      const count =
        getPaginationCount();

      if (
        count <= 1 ||
        maxScroll() <= 2
      ) {
        pagination.innerHTML = '';
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      const currentCount =
        pagination.querySelectorAll(
          '[data-pagination-dot]'
        ).length;

      if (
        currentCount !== count
      ) {
        pagination.innerHTML = '';

        const fragment =
          document.createDocumentFragment();

        for (
          let index = 0;
          index < count;
          index++
        ) {
          const dot =
            document.createElement(
              'button'
            );

          dot.type = 'button';

          dot.className =
            'shop-range__pagination-dot';

          dot.dataset.paginationDot =
            '';

          dot.dataset.paginationIndex =
            String(index);

          dot.setAttribute(
            'aria-label',
            `Go to slide ${index + 1}`
          );

          fragment.appendChild(dot);
        }

        pagination.appendChild(
          fragment
        );
      }

      updatePagination();
    };

    const scrollToPagination = index => {
      if (!slider) return;

      const slideStep = step();

      if (slideStep <= 0) return;

      const target =
        Math.min(
          Math.max(
            index * slideStep,
            0
          ),
          maxScroll()
        );

      slider.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    };

    /* ============================================================
       MOVE SLIDER
    ============================================================ */

    const move = direction => {
      if (
        !slider ||
        maxScroll() <= 2
      ) {
        return;
      }

      const loop =
        section.dataset.loop ===
        'true';

      if (
        direction > 0 &&
        atEnd()
      ) {
        if (loop) {
          slider.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          stopAutoplay();
        }

        return;
      }

      if (
        direction < 0 &&
        atStart()
      ) {
        if (loop) {
          slider.scrollTo({
            left: maxScroll(),
            behavior: 'smooth'
          });
        }

        return;
      }

      slider.scrollBy({
        left:
          direction * step(),
        behavior: 'smooth'
      });
    };

    /* ============================================================
       ARROW EVENTS
    ============================================================ */

    on(
      prev,
      'click',
      () => {
        move(-1);
      }
    );

    on(
      next,
      'click',
      () => {
        move(1);
      }
    );

    /* ============================================================
       PAGINATION CLICK
    ============================================================ */

    on(
      pagination,
      'click',
      event => {
        const dot =
          event.target.closest(
            '[data-pagination-dot]'
          );

        if (!dot) return;

        const index =
          parseInt(
            dot.dataset
              .paginationIndex ||
              '0',
            10
          );

        scrollToPagination(index);
      }
    );

    /* ============================================================
       SLIDER SCROLL / DRAG
    ============================================================ */

    if (slider) {
      on(
        slider,
        'scroll',
        () => {
          if (scrollRaf) {
            cancelAnimationFrame(
              scrollRaf
            );
          }

          scrollRaf =
            requestAnimationFrame(
              () => {
                updateArrows();
                updatePagination();

                scrollRaf = null;
              }
            );
        },
        {
          passive: true
        }
      );

      if (
        section.dataset.drag ===
        'true'
      ) {
        on(
          slider,
          'pointerdown',
          event => {
            if (
              event.pointerType !==
                'mouse' ||
              event.target.closest(
                'a,button,input,select,label'
              )
            ) {
              return;
            }

            dragging = true;

            startX =
              event.clientX;

            startScroll =
              slider.scrollLeft;

            slider.setPointerCapture(
              event.pointerId
            );

            stopAutoplay();
          }
        );

        on(
          slider,
          'pointermove',
          event => {
            if (!dragging) return;

            slider.scrollLeft =
              startScroll -
              (
                event.clientX -
                startX
              );
          }
        );

        on(
          slider,
          'pointerup',
          event => {
            dragging = false;

            try {
              slider.releasePointerCapture(
                event.pointerId
              );
            } catch (error) {}

            startAutoplay();
          }
        );

        on(
          slider,
          'pointercancel',
          () => {
            dragging = false;
            startAutoplay();
          }
        );
      }
    }

    /* ============================================================
       AUTOPLAY PAUSE EVENTS
    ============================================================ */

    on(
      section,
      'mouseenter',
      stopAutoplay
    );

    on(
      section,
      'mouseleave',
      startAutoplay
    );

    on(
      section,
      'focusin',
      stopAutoplay
    );

    on(
      section,
      'focusout',
      startAutoplay
    );

    on(
      document,
      'visibilitychange',
      () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      }
    );

    /* ============================================================
       RESIZE
    ============================================================ */

    on(
      window,
      'resize',
      () => {
        if (resizeTimer) {
          window.clearTimeout(
            resizeTimer
          );
        }

        resizeTimer =
          window.setTimeout(
            () => {
              updateArrows();
              buildPagination();

              if (
                section.dataset
                  .autoplay ===
                'true'
              ) {
                startAutoplay();
              }
            },
            120
          );
      },
      {
        passive: true
      }
    );

    /* ============================================================
       INITIAL STATE
    ============================================================ */

    requestAnimationFrame(() => {
      updateArrows();
      buildPagination();
      startAutoplay();
    });

    /* ============================================================
       CLEANUP
    ============================================================ */

    section._shopRangeCleanup =
      () => {
        stopAutoplay();

        if (scrollRaf) {
          cancelAnimationFrame(
            scrollRaf
          );

          scrollRaf = null;
        }

        if (resizeTimer) {
          window.clearTimeout(
            resizeTimer
          );

          resizeTimer = null;
        }

        cleanups
          .splice(0)
          .forEach(cleanup => {
            cleanup();
          });

        delete section
          ._shopRangeCleanup;

        delete section.dataset
          .shopRangeInitialized;
      };
  };

  /* ==============================================================
     INITIALIZE ALL
  ============================================================== */

  const initAll = root => {
    if (!root) return;

    if (
      root.matches &&
      root.matches(selector)
    ) {
      init(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(selector)
        .forEach(init);
    }
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAll(document);
      },
      {
        once: true
      }
    );
  } else {
    initAll(document);
  }

  /* ==============================================================
     SHOPIFY THEME EDITOR
  ============================================================== */

  document.addEventListener(
    'shopify:section:load',
    event => {
      initAll(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {
      const section =
        getSection(event.target);

      if (
        section &&
        section._shopRangeCleanup
      ) {
        section._shopRangeCleanup();
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-review-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOcoaReviewSlider(section) {
      if (!section || section.dataset.sliderInitialized === 'true') {
        return;
      }

      section.dataset.sliderInitialized = 'true';

      const viewport = section.querySelector('[data-review-viewport]');
      const track = section.querySelector('[data-review-track]');
      const prevButton = section.querySelector('[data-review-prev]');
      const nextButton = section.querySelector('[data-review-next]');
      const dots = Array.from(
        section.querySelectorAll('[data-dot-index]')
      );

      if (!viewport || !track) {
        return;
      }

      let originalCards = Array.from(
        track.querySelectorAll('[data-original-slide]')
      );

      const originalCount = originalCards.length;

      if (originalCount <= 1) {
        if (prevButton) prevButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
        return;
      }

      let currentIndex = 0;
      let scrollTimer = null;
      let isProgrammaticScroll = false;


      /*
        No cloned card: the first review must not
        appear twice. Arrows rewind at the ends instead.
      */


      /* =====================================================
         HELPERS
         ===================================================== */

      function getOriginalCards() {
        return Array.from(
          track.querySelectorAll('[data-original-slide]')
        );
      }


      function getMaxScroll() {
        return viewport.scrollWidth - viewport.clientWidth;
      }


      /*
        Last index that actually moves the track
        (later cards are already visible at the scroll end).
      */
      function getLastReachableIndex() {
        const step = getStep();

        if (!step) return originalCount - 1;

        return Math.min(
          originalCount - 1,
          Math.round(getMaxScroll() / step)
        );
      }


      function getGap() {
        const styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 0);
      }


      function getStep() {
        const cards = getOriginalCards();

        if (!cards.length) return 0;

        return cards[0].getBoundingClientRect().width + getGap();
      }


      function updateDots(index) {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;

          dot.classList.toggle('is-active', active);

          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }


      function scrollToIndex(index, behavior = 'smooth') {
        const step = getStep();

        if (!step) return;

        currentIndex = index;

        updateDots(currentIndex);

        isProgrammaticScroll = true;

        viewport.scrollTo({
          left: Math.min(step * index, getMaxScroll()),
          behavior: behavior
        });

        window.setTimeout(() => {
          isProgrammaticScroll = false;
        }, behavior === 'smooth' ? 500 : 30);
      }


      /* =====================================================
         NEXT
         ===================================================== */

      function goNext() {
        const nextIndex = currentIndex + 1;

        /*
          At the end of the reviews, rewind to the first card.
        */
        if (
          nextIndex > getLastReachableIndex() ||
          viewport.scrollLeft >= getMaxScroll() - 2
        ) {
          scrollToIndex(0);
          return;
        }

        scrollToIndex(nextIndex);
      }


      /* =====================================================
         PREVIOUS
         ===================================================== */

      function goPrev() {
        /*
          On the first card, jump to the end of the reviews.
        */
        if (currentIndex <= 0) {
          currentIndex = getLastReachableIndex();

          updateDots(currentIndex);

          isProgrammaticScroll = true;

          viewport.scrollTo({
            left: getMaxScroll(),
            behavior: 'smooth'
          });

          window.setTimeout(() => {
            isProgrammaticScroll = false;
          }, 500);

          return;
        }

        scrollToIndex(
          Math.min(currentIndex, getLastReachableIndex()) - 1
        );
      }


      /* =====================================================
         ARROW EVENTS
         ===================================================== */

      if (nextButton) {
        nextButton.addEventListener('click', goNext);
      }

      if (prevButton) {
        prevButton.addEventListener('click', goPrev);
      }


      /* =====================================================
         DOT EVENTS
         ===================================================== */

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.dotIndex);

          if (!Number.isNaN(index)) {
            scrollToIndex(index);
          }
        });
      });


      /* =====================================================
         MOBILE / TOUCH SCROLL DETECTION
         Updates dots after native swipe.
         ===================================================== */

      viewport.addEventListener(
        'scroll',
        () => {
          if (isProgrammaticScroll) {
            return;
          }

          window.clearTimeout(scrollTimer);

          scrollTimer = window.setTimeout(() => {
            const step = getStep();

            if (!step) return;

            let nearestIndex = Math.round(viewport.scrollLeft / step);

            /*
              User manually swiped onto cloned first card.
              Reset back to real first card.
            */
            if (nearestIndex >= originalCount) {
              currentIndex = 0;

              updateDots(0);

              viewport.scrollTo({
                left: 0,
                behavior: 'auto'
              });

              return;
            }

            nearestIndex = Math.max(
              0,
              Math.min(nearestIndex, originalCount - 1)
            );

            currentIndex = nearestIndex;

            updateDots(currentIndex);
          }, 90);
        },
        { passive: true }
      );


      /* =====================================================
         MOUSE DRAG SUPPORT
         Desktop drag without any library
         ===================================================== */

      let pointerDown = false;
      let pointerStartX = 0;
      let pointerStartScroll = 0;
      let pointerMoved = false;

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') {
          return;
        }

        pointerDown = true;
        pointerMoved = false;
        pointerStartX = event.clientX;
        pointerStartScroll = viewport.scrollLeft;

        viewport.setPointerCapture?.(event.pointerId);
      });


      viewport.addEventListener('pointermove', (event) => {
        if (!pointerDown) return;

        const distance = event.clientX - pointerStartX;

        if (Math.abs(distance) > 4) {
          pointerMoved = true;
        }

        viewport.scrollLeft = pointerStartScroll - distance;
      });


      function finishPointerDrag(event) {
        if (!pointerDown) return;

        pointerDown = false;

        try {
          viewport.releasePointerCapture?.(event.pointerId);
        } catch (error) {}

        const step = getStep();

        if (!step) return;

        let nearestIndex = Math.round(viewport.scrollLeft / step);

        if (nearestIndex >= originalCount) {
          nearestIndex = 0;

          viewport.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
        } else {
          nearestIndex = Math.max(
            0,
            Math.min(nearestIndex, originalCount - 1)
          );

          viewport.scrollTo({
            left: nearestIndex * step,
            behavior: 'smooth'
          });
        }

        currentIndex = nearestIndex;
        updateDots(currentIndex);
      }


      viewport.addEventListener('pointerup', finishPointerDrag);
      viewport.addEventListener('pointercancel', finishPointerDrag);


      /* =====================================================
         PREVENT LINK CLICK AFTER DESKTOP DRAG
         ===================================================== */

      viewport.addEventListener(
        'click',
        (event) => {
          if (pointerMoved) {
            event.preventDefault();
            event.stopPropagation();

            pointerMoved = false;
          }
        },
        true
      );


      /* =====================================================
         RESIZE
         Keeps current card aligned.
         ===================================================== */

      if (section.__reviewResizeHandler) {
        window.removeEventListener('resize', section.__reviewResizeHandler);
      }

      let resizeTimer;

      section.__reviewResizeHandler = () => {
        window.clearTimeout(resizeTimer);

        resizeTimer = window.setTimeout(() => {
          scrollToIndex(currentIndex, 'auto');
        }, 120);
      };

      window.addEventListener('resize', section.__reviewResizeHandler);


      /* =====================================================
         AUTOPLAY (optional, set in the theme editor)
         Advances like the Next arrow, rewinds at the end.
         Pauses on hover / focus / touch / drag, when the
         section is off-screen or the tab is hidden.
         ===================================================== */

      if (section.__reviewAutoplayTimer) {
        window.clearInterval(section.__reviewAutoplayTimer);
        section.__reviewAutoplayTimer = null;
      }

      const wantsAutoplay = section.dataset.autoplay === 'true';
      const reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (wantsAutoplay && !reduceMotion) {
        const delay = Math.max(2, parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
        let hovering = false;
        let touching = false;
        let inView = true;
        let resumeAt = 0;

        const holdAfterTouch = () => {
          resumeAt = Date.now() + 6000;
        };

        section.addEventListener('mouseenter', () => { hovering = true; });
        section.addEventListener('mouseleave', () => { hovering = false; });
        section.addEventListener('focusin', () => { hovering = true; });
        section.addEventListener('focusout', () => { hovering = false; });
        viewport.addEventListener('pointerdown', () => { touching = true; });
        viewport.addEventListener('pointerup', () => { touching = false; holdAfterTouch(); });
        viewport.addEventListener('pointercancel', () => { touching = false; holdAfterTouch(); });
        dots.forEach((dot) => dot.addEventListener('click', holdAfterTouch));
        if (prevButton) prevButton.addEventListener('click', holdAfterTouch);
        if (nextButton) nextButton.addEventListener('click', holdAfterTouch);

        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            inView = entries[0].isIntersecting;
          }, { threshold: 0.25 }).observe(section);
        }

        section.__reviewAutoplayTimer = window.setInterval(() => {
          if (hovering || touching || !inView || document.hidden || Date.now() < resumeAt) return;
          goNext();
        }, delay);
      }


      /* Initial state */

      updateDots(0);
    }


    document.querySelectorAll('.ocoa-reviews-slider').forEach(initOcoaReviewSlider);


    /* Shopify Theme Editor support */

    document.addEventListener('shopify:section:load', (event) => {
      const loadedSection =
        event.target.matches && event.target.matches('.ocoa-reviews-slider')
          ? event.target
          : event.target.querySelector && event.target.querySelector('.ocoa-reviews-slider');

      if (loadedSection) {
        loadedSection.dataset.sliderInitialized = 'false';
        initOcoaReviewSlider(loadedSection);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const unloadedSection =
        event.target.matches && event.target.matches('.ocoa-reviews-slider')
          ? event.target
          : event.target.querySelector && event.target.querySelector('.ocoa-reviews-slider');

      if (unloadedSection && unloadedSection.__reviewResizeHandler) {
        window.removeEventListener('resize', unloadedSection.__reviewResizeHandler);
      }

      if (unloadedSection && unloadedSection.__reviewAutoplayTimer) {
        window.clearInterval(unloadedSection.__reviewAutoplayTimer);
        unloadedSection.__reviewAutoplayTimer = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-test"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-shop-range]';

  const getSection = target => {
    if (!target) return null;
    if (target.matches && target.matches(selector)) return target;
    return target.querySelector ? target.querySelector(selector) : null;
  };

  const init = section => {
    if (!section || section.dataset.shopRangeInitialized === 'true') return;
    section.dataset.shopRangeInitialized = 'true';

    const addLabel = section.dataset.addLabel || 'ADD TO BAG';
    const soldLabel = section.dataset.soldLabel || 'SOLD OUT';
    const cartAddUrl = section.dataset.cartAddUrl || '/cart/add.js';
    const cartUrl = section.dataset.cartUrl || '/cart';
    const cleanups = [];

    const on = (element, type, handler, options) => {
      if (!element) return;
      element.addEventListener(type, handler, options);
      cleanups.push(() => element.removeEventListener(type, handler, options));
    };

    const getMeta = (card, variantId) => {
      if (!card._srVariants) {
        const node = card.querySelector('[data-variant-data]');
        try {
          const list = node ? JSON.parse(node.textContent) : [];
          card._srVariants = new Map(list.map(item => [String(item.id), item]));
        } catch (error) {
          console.error('Shop The Range - variant data error:', error);
          card._srVariants = new Map();
        }
      }
      return card._srVariants.get(String(variantId));
    };

    const setPurchaseMode = (card, mode) => {
      const toggle = card.querySelector('[data-purchase-toggle]');
      const sub = card.querySelector('[data-purchase-sub]');
      const one = card.querySelector('[data-purchase-one]');
      const input = card.querySelector('[data-cart-selling-plan]');
      const canSubscribe = Boolean(toggle && sub && !sub.classList.contains('is-hidden') && sub.dataset.planId);
      const useSubscription = mode === 'sub' && canSubscribe;

      card.dataset.purchaseMode = useSubscription ? 'sub' : 'one';

      if (sub) {
        sub.classList.toggle('is-active', useSubscription);
        sub.setAttribute('aria-pressed', useSubscription ? 'true' : 'false');
      }
      if (one) {
        one.classList.toggle('is-active', !useSubscription);
        one.setAttribute('aria-pressed', useSubscription ? 'false' : 'true');
      }
      if (input) {
        input.value = useSubscription && sub ? sub.dataset.planId : '';
        input.disabled = !useSubscription;
      }
    };

    const updatePurchase = (card, meta) => {
      const toggle = card.querySelector('[data-purchase-toggle]');
      const staticRow = card.querySelector('[data-purchase-static]');
      const sub = card.querySelector('[data-purchase-sub]');
      const one = card.querySelector('[data-purchase-one]');

      if (toggle) toggle.classList.remove('is-hidden');
      if (staticRow) staticRow.classList.add('is-hidden');

      if (meta && meta.hasPlans && meta.planId) {
        if (toggle) toggle.classList.remove('is-one-time-only');
        if (sub) {
          sub.classList.remove('is-hidden');
          sub.dataset.planId = String(meta.planId);
          sub.dataset.price = meta.subPrice || '';
        }
        if (one) one.dataset.price = meta.price || '';
        setPurchaseMode(card, card.dataset.purchasePreference === 'one' ? 'one' : 'sub');
        return;
      }

      if (toggle) toggle.classList.add('is-one-time-only');
      if (sub) {
        sub.classList.add('is-hidden');
        sub.classList.remove('is-active');
        sub.dataset.planId = '';
        sub.dataset.price = '';
        sub.setAttribute('aria-pressed', 'false');
      }
      if (one) one.dataset.price = meta ? (meta.price || '') : '';
      setPurchaseMode(card, 'one');
    };

    const updatePrice = card => {
      const price = card.querySelector('[data-atc-price]');
      if (!price) return;

      const mode = card.dataset.purchaseMode || 'one';
      const modeButton = card.querySelector(mode === 'sub' ? '[data-purchase-sub]' : '[data-purchase-one]');
      const modePrice = modeButton ? modeButton.dataset.price : '';

      if (modePrice) {
        price.textContent = modePrice;
        return;
      }

      const meta = getMeta(card, card.dataset.currentVariant);
      if (meta && meta.price) price.textContent = meta.price;
    };

    const updateAvailability = (card, available) => {
      const button = card.querySelector('[data-add-to-bag]');
      const label = card.querySelector('[data-atc-label]');
      const dot = card.querySelector('[data-atc-dot]');
      const price = card.querySelector('[data-atc-price]');
      if (!button || !label) return;

      button.disabled = !available;
      label.textContent = available ? addLabel : soldLabel;
      if (dot) dot.hidden = !available;
      if (price) price.hidden = !available;
    };

    const updateImage = (card, meta) => {
      if (!meta || !meta.image) return;
      const image = card.querySelector('[data-product-image]');
      if (!image) return;

      image.src = meta.image;
      if (meta.srcset) image.srcset = meta.srcset;
      else image.removeAttribute('srcset');
      if (meta.width) image.width = meta.width;
      if (meta.height) image.height = meta.height;
      image.alt = meta.alt || '';
    };

    const selectVariant = (card, variantId) => {
      const meta = getMeta(card, variantId);
      if (!meta) return;

      variantId = String(variantId);
      card.dataset.currentVariant = variantId;

      const input = card.querySelector('[data-cart-variant-id]');
      if (input) input.value = variantId;

      card.querySelectorAll('[data-variant-button]').forEach(button => {
        const active = button.dataset.variantId === variantId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const select = card.querySelector('[data-variant-select]');
      if (select && select.value !== variantId) select.value = variantId;

      updatePurchase(card, meta);
      updatePrice(card);
      updateAvailability(card, Boolean(meta.available));
      updateImage(card, meta);
    };

    section.querySelectorAll('[data-product-card]').forEach(card => {
      card.dataset.purchasePreference = card.dataset.purchasePreference || 'sub';
      const meta = getMeta(card, card.dataset.currentVariant);
      updatePurchase(card, meta);
      updatePrice(card);
    });

    on(section, 'click', event => {
      const variant = event.target.closest('[data-variant-button]');
      if (variant && !variant.disabled) {
        const card = variant.closest('[data-product-card]');
        if (card) selectVariant(card, variant.dataset.variantId);
        return;
      }

      const purchase = event.target.closest('[data-purchase-sub], [data-purchase-one]');
      if (!purchase) return;
      const card = purchase.closest('[data-product-card]');
      if (!card) return;

      if (purchase.matches('[data-purchase-sub]')) {
        if (!purchase.dataset.planId) return;
        card.dataset.purchasePreference = 'sub';
        setPurchaseMode(card, 'sub');
      } else {
        card.dataset.purchasePreference = 'one';
        setPurchaseMode(card, 'one');
      }
      updatePrice(card);
    });

    on(section, 'change', event => {
      if (!event.target.matches('[data-variant-select]')) return;
      const card = event.target.closest('[data-product-card]');
      if (card) selectVariant(card, event.target.value);
    });

    on(section, 'submit', async event => {
      const form = event.target.closest('[data-shop-range-form]');
      if (!form) return;
      event.preventDefault();

      const addButton = form.querySelector('[data-add-to-bag]');
      if (!addButton || addButton.disabled) return;

      addButton.disabled = true;
      addButton.classList.add('is-loading');

      const modalCart = Boolean(window.theme && window.theme.settings && window.theme.settings.cart_type === 'modal');

      try {
        const formData = new FormData(form);

        if (modalCart) {
          formData.append('sections', 'cart-items,cart-footer,cart-item-count');
          formData.append('sections_url', window.location.pathname);
        }

        const endpoint = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || cartAddUrl;
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        });

        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to add product to cart.');
        }

        if (modalCart) {
          document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', {
            bubbles: true,
            detail: { response: result }
          }));

          if (window.Alpine && result.sections && result.sections['cart-item-count']) {
            try {
              const doc = new DOMParser().parseFromString(result.sections['cart-item-count'], 'text/html');
              const element = doc.body.firstElementChild;
              const count = element ? parseInt(element.innerText.trim(), 10) : NaN;
              if (!Number.isNaN(count)) window.Alpine.store('cart_count').count = count;
            } catch (error) {
              console.warn('Shop The Range - could not sync cart count:', error);
            }
          }
        } else {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart_url) || cartUrl;
        }
      } catch (error) {
        console.error('Shop The Range - Add to cart error:', error);
        alert(error.message);
      } finally {
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
      }
    });

    const slider = section.querySelector('[data-shop-range-slider]');
    const prev = section.querySelector('[data-slider-prev]');
    const next = section.querySelector('[data-slider-next]');
    let timer = null;
    let dragging = false;
    let startX = 0;
    let startScroll = 0;

    const cards = () => slider ? Array.from(slider.querySelectorAll('[data-product-card]')) : [];
    const maxScroll = () => slider ? Math.max(0, slider.scrollWidth - slider.clientWidth) : 0;
    const atStart = () => !slider || slider.scrollLeft <= 2;
    const atEnd = () => !slider || slider.scrollLeft >= maxScroll() - 2;

    const stopAutoplay = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const updateArrows = () => {
      const hasOverflow = Boolean(slider && maxScroll() > 2);
      const loop = section.dataset.loop === 'true';
      if (prev) prev.disabled = !hasOverflow || (!loop && atStart());
      if (next) next.disabled = !hasOverflow || (!loop && atEnd());
    };

    const step = () => {
      const first = cards()[0];
      if (!first || !slider) return slider ? slider.clientWidth : 0;
      const computed = getComputedStyle(slider);
      const gap = parseFloat(computed.columnGap || computed.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const move = direction => {
      if (!slider || maxScroll() <= 2) return;
      const loop = section.dataset.loop === 'true';

      if (direction > 0 && atEnd()) {
        if (loop) slider.scrollTo({ left: 0, behavior: 'smooth' });
        else stopAutoplay();
        return;
      }

      if (direction < 0 && atStart()) {
        if (loop) slider.scrollTo({ left: maxScroll(), behavior: 'smooth' });
        return;
      }

      slider.scrollBy({ left: direction * step(), behavior: 'smooth' });
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!slider || section.dataset.autoplay !== 'true' || document.hidden || maxScroll() <= 2) return;
      const delay = Math.max(2000, parseInt(section.dataset.autoplaySpeed || '5000', 10));
      timer = window.setInterval(() => move(1), delay);
    };

    on(prev, 'click', () => move(-1));
    on(next, 'click', () => move(1));

    if (slider) {
      on(slider, 'scroll', updateArrows, { passive: true });

      if (section.dataset.drag === 'true') {
        on(slider, 'pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.target.closest('a,button,input,select,label')) return;
          dragging = true;
          startX = event.clientX;
          startScroll = slider.scrollLeft;
          slider.setPointerCapture(event.pointerId);
        });
        on(slider, 'pointermove', event => {
          if (dragging) slider.scrollLeft = startScroll - (event.clientX - startX);
        });
        on(slider, 'pointerup', () => { dragging = false; });
        on(slider, 'pointercancel', () => { dragging = false; });
      }
    }

    on(section, 'mouseenter', stopAutoplay);
    on(section, 'mouseleave', startAutoplay);
    on(section, 'focusin', stopAutoplay);
    on(section, 'focusout', startAutoplay);
    on(document, 'visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
    on(window, 'resize', () => {
      updateArrows();
      if (section.dataset.autoplay === 'true') startAutoplay();
    }, { passive: true });

    updateArrows();
    startAutoplay();

    section._shopRangeCleanup = () => {
      stopAutoplay();
      cleanups.splice(0).forEach(cleanup => cleanup());
      delete section._shopRangeCleanup;
      delete section.dataset.shopRangeInitialized;
    };
  };

  const initAll = root => {
    if (!root) return;
    if (root.matches && root.matches(selector)) init(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const section = getSection(event.target);
    if (section && section._shopRangeCleanup) section._shopRangeCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-landing-travel-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTravelKitSlider(section) {
      if (!section || section.dataset.sliderInitialized === 'true') return;

      section.dataset.sliderInitialized = 'true';

      const viewport = section.querySelector('.travel-kit-slider__viewport');
      const track = section.querySelector('.travel-kit-slider__track');
      const slides = Array.from(
        section.querySelectorAll('.travel-kit-slider__slide')
      );
      const dots = Array.from(
        section.querySelectorAll('.travel-kit-slider__dot')
      );

      if (!viewport || !track || slides.length <= 1) return;

      let currentIndex = 0;
      let autoplayTimer = null;

      let pointerStartX = 0;
      let pointerCurrentX = 0;
      let isDragging = false;

      const autoplayEnabled =
        section.dataset.autoplay === 'true';

      const autoplaySpeed =
        parseInt(section.dataset.autoplaySpeed, 10) || 5000;


      /* ---------------------------------------------
         GO TO SLIDE
      --------------------------------------------- */

      function goToSlide(index, restart = true) {
        if (index < 0) {
          index = slides.length - 1;
        }

        if (index >= slides.length) {
          index = 0;
        }

        currentIndex = index;

        track.style.transition =
          'transform 650ms cubic-bezier(.22,.61,.36,1)';

        track.style.transform =
          `translate3d(-${currentIndex * 100}%, 0, 0)`;

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle(
            'is-active',
            slideIndex === currentIndex
          );

          slide.setAttribute(
            'aria-hidden',
            slideIndex === currentIndex ? 'false' : 'true'
          );
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === currentIndex;

          dot.classList.toggle('is-active', active);

          dot.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        if (restart) {
          restartAutoplay();
        }
      }


      /* ---------------------------------------------
         NEXT / PREVIOUS
      --------------------------------------------- */

      function nextSlide() {
        goToSlide(currentIndex + 1, false);
      }

      function previousSlide() {
        goToSlide(currentIndex - 1);
      }


      /* ---------------------------------------------
         AUTOPLAY
      --------------------------------------------- */

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (!autoplayEnabled) return;

        stopAutoplay();

        autoplayTimer = setInterval(() => {
          nextSlide();
        }, autoplaySpeed);
      }

      function restartAutoplay() {
        if (!autoplayEnabled) return;

        stopAutoplay();
        startAutoplay();
      }


      /* ---------------------------------------------
         PAGINATION
      --------------------------------------------- */

      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = Number(this.dataset.slideTo);

          if (!Number.isNaN(index)) {
            goToSlide(index);
          }
        });

        dot.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
          event.preventDefault();

          const index = Number(this.dataset.slideTo);

          if (!Number.isNaN(index)) {
            goToSlide(index);
          }
        });
      });

      viewport.addEventListener('keydown', function (event) {

  // Desktop only
  if (window.innerWidth <= 749) return;

  if (event.key === 'ArrowLeft') {
    event.preventDefault();

    previousSlide();
    restartAutoplay();
  }

  if (event.key === 'ArrowRight') {
    event.preventDefault();

    nextSlide();
    restartAutoplay();
  }

});


      /* ---------------------------------------------
         TOUCH / POINTER SWIPE
      --------------------------------------------- */

      viewport.addEventListener('pointerdown', function (event) {
        if (
          event.target.closest('a') ||
          event.target.closest('button')
        ) {
          return;
        }

        isDragging = true;

        pointerStartX = event.clientX;
        pointerCurrentX = pointerStartX;

        stopAutoplay();

        viewport.setPointerCapture?.(event.pointerId);
      });


      viewport.addEventListener('pointermove', function (event) {
        if (!isDragging) return;

        pointerCurrentX = event.clientX;

        const difference = pointerCurrentX - pointerStartX;
        const width = viewport.offsetWidth;

        if (!width) return;

        const dragPercentage =
          (difference / width) * 100;

        const baseTranslate =
          currentIndex * -100;

        track.style.transition = 'none';

        track.style.transform =
          `translate3d(${baseTranslate + dragPercentage}%, 0, 0)`;
      });


      function endDrag() {
        if (!isDragging) return;

        isDragging = false;

        const distance =
          pointerCurrentX - pointerStartX;

        const threshold =
          Math.min(viewport.offsetWidth * 0.12, 80);

        if (Math.abs(distance) > threshold) {
          if (distance < 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        } else {
          goToSlide(currentIndex);
        }

        startAutoplay();
      }


      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);


      /* ---------------------------------------------
         PAUSE ON HOVER
      --------------------------------------------- */

      section.addEventListener('mouseenter', function () {
        stopAutoplay();
      });

      section.addEventListener('mouseleave', function () {
        startAutoplay();
      });


      /* ---------------------------------------------
         TAB VISIBILITY
      --------------------------------------------- */

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });


      /* ---------------------------------------------
         INITIAL STATE
      --------------------------------------------- */

      goToSlide(0, false);
      startAutoplay();

      section.__ttStopAutoplay = stopAutoplay;
    }


    function initializeAllTravelKitSliders() {
      document
        .querySelectorAll('.travel-kit-slider')
        .forEach(initTravelKitSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeAllTravelKitSliders
      );
    } else {
      initializeAllTravelKitSliders();
    }


    /* Shopify Theme Editor support */
    document.addEventListener(
      'shopify:section:load',
      function (event) {
        const slider =
          event.target.querySelector('.travel-kit-slider') ||
          (
            event.target.classList &&
            event.target.classList.contains('travel-kit-slider')
              ? event.target
              : null
          );

        if (slider) {
          slider.dataset.sliderInitialized = 'false';
          initTravelKitSlider(slider);
        }
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      function (event) {
        const slider =
          event.target.querySelector('.travel-kit-slider') ||
          (
            event.target.classList &&
            event.target.classList.contains('travel-kit-slider')
              ? event.target
              : null
          );

        if (slider && slider.__ttStopAutoplay) {
          slider.__ttStopAutoplay();
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocoa-promo-pdp-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
    window.PromoProductHero = window.PromoProductHero || {};

    if (!window.PromoProductHero.init) {
      window.PromoProductHero.init = (section) => {
        if (!section || section.dataset.pphInitialized === 'true') return;

        section.dataset.pphInitialized = 'true';

        const slider = section.querySelector('[data-pph-slider]');
        if (!slider) return;

        const slides = Array.from(section.querySelectorAll('[data-pph-slide]'));
        const indicators = Array.from(section.querySelectorAll('[data-pph-indicator]'));
        const prevButton = section.querySelector('[data-pph-prev]');
        const nextButton = section.querySelector('[data-pph-next]');

        if (!slides.length) return;

        const autoplayEnabled = slider.dataset.autoplay === 'true';
        const autoplaySpeed = Number(slider.dataset.autoplaySpeed) || 4000;
        const infiniteLoop = slider.dataset.loop === 'true';
        const swipeEnabled = slider.dataset.swipe === 'true';
        const pauseOnHover = slider.dataset.pauseHover === 'true';

        let activeIndex = 0;
        let autoplayTimer = null;
        let pointerStartX = null;
        let didSwipe = false;

        const normalizeIndex = (index) => {
          if (infiniteLoop) {
            return (index + slides.length) % slides.length;
          }

          return Math.max(0, Math.min(index, slides.length - 1));
        };

        const updateArrowState = () => {
          if (!prevButton || !nextButton) return;

          if (infiniteLoop) {
            prevButton.disabled = false;
            nextButton.disabled = false;
            return;
          }

          prevButton.disabled = activeIndex === 0;
          nextButton.disabled = activeIndex === slides.length - 1;
        };

        const showSlide = (index) => {
          activeIndex = normalizeIndex(index);

          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('is-active', slideIndex === activeIndex);
          });

          indicators.forEach((indicator, indicatorIndex) => {
            const isActive = indicatorIndex === activeIndex;
            indicator.classList.toggle('is-active', isActive);
            indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
          });

          updateArrowState();
        };

        const stopAutoplay = () => {
          if (!autoplayTimer) return;
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        const nextSlide = () => {
          if (!infiniteLoop && activeIndex >= slides.length - 1) {
            stopAutoplay();
            return;
          }

          showSlide(activeIndex + 1);
        };

        const previousSlide = () => {
          showSlide(activeIndex - 1);
        };

        const startAutoplay = () => {
          stopAutoplay();

          if (!autoplayEnabled || slides.length <= 1) return;
          if (!infiniteLoop && activeIndex >= slides.length - 1) return;

          autoplayTimer = setInterval(nextSlide, autoplaySpeed);
        };

        indicators.forEach((indicator) => {
          indicator.addEventListener('click', () => {
            showSlide(Number(indicator.dataset.slideIndex));
            startAutoplay();
          });
        });

        prevButton?.addEventListener('click', () => {
          previousSlide();
          startAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          nextSlide();
          startAutoplay();
        });

        if (pauseOnHover && autoplayEnabled) {
          slider.addEventListener('mouseenter', stopAutoplay);
          slider.addEventListener('mouseleave', startAutoplay);
        }

        if (swipeEnabled && slides.length > 1) {
          slider.style.touchAction = 'pan-y';

          slider.addEventListener('pointerdown', (event) => {
            pointerStartX = event.clientX;
            didSwipe = false;
          });

          slider.addEventListener('pointerup', (event) => {
            if (pointerStartX === null) return;

            const distance = event.clientX - pointerStartX;
            pointerStartX = null;

            if (Math.abs(distance) < 40) return;

            didSwipe = true;

            if (distance < 0) {
              nextSlide();
            } else {
              previousSlide();
            }

            startAutoplay();
          });

          slider.addEventListener('pointercancel', () => {
            pointerStartX = null;
          });

          slider.addEventListener(
            'click',
            (event) => {
              if (!didSwipe) return;
              event.preventDefault();
              event.stopPropagation();
              didSwipe = false;
            },
            true
          );
        }

        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopAutoplay();
          } else {
            startAutoplay();
          }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        section.__pphShowSlide = showSlide;
        section.__pphCleanup = () => {
          stopAutoplay();
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };

        showSlide(0);
        startAutoplay();
      };
    }

    if (!window.PromoProductHero.editorEventsBound) {
      window.PromoProductHero.editorEventsBound = true;

      document.addEventListener('shopify:section:load', (event) => {
        const section =
          event.target.matches?.('[data-pph-section]')
            ? event.target
            : event.target.querySelector?.('[data-pph-section]');

        if (section) {
          window.PromoProductHero.init(section);
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        const section =
          event.target.matches?.('[data-pph-section]')
            ? event.target
            : event.target.querySelector?.('[data-pph-section]');

        section?.__pphCleanup?.();
      });

      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest?.('[data-pph-slide]');
        const section = block?.closest?.('[data-pph-section]');

        if (!block || !section || !section.__pphShowSlide) return;

        section.__pphShowSlide(Number(block.dataset.slideIndex));
      });
    }

    document.querySelectorAll('[data-pph-section]').forEach((section) => {
      window.PromoProductHero.init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
